import { create } from 'zustand';
import { getSportsData } from '@/api/sport/sportApi';
import { SPORT_DATA_FIELDS } from '@/api/sport/sport-fields.config';
import type { SportData } from '@/types/sports.model';

interface SportsState {
  sportsData: SportData[];
  isLoading: boolean;
  error: string | null;
  isInitialized: boolean;
  fetchSports: () => Promise<void>;
  reset: () => void;
}

export const useSportsStore = create<SportsState>((set, get) => ({
  sportsData: [],
  isLoading: false,
  error: null,
  isInitialized: false,

  fetchSports: async () => {
    const state = get();
    if (state.isInitialized || state.isLoading) return;

    set({ isLoading: true, error: null });
    try {
      const data = await getSportsData(SPORT_DATA_FIELDS.FULL);
      set({ sportsData: data, isLoading: false, isInitialized: true });
    } catch (error) {
      console.error('Error fetching sports data:', error);
      set({ error: 'No se pudieron cargar los deportes', isLoading: false });
    }
  },

  reset: () =>
    set({ sportsData: [], isLoading: false, error: null, isInitialized: false }),
}));


